import { OpenMarketsError } from "../errors.js";
import { contestStateSchema, contestStateBatchSchema } from "../schemas/index.js";
export class ContestStateResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /**
     * Live state for one contest. A 404 `not_found` here is NORMAL pregame (no
     * state cached yet), so we translate it to `data: null` rather than throwing —
     * callers shouldn't have to special-case an expected condition. Any other error
     * still propagates.
     */
    async get(contestId) {
        try {
            return await this.http.request({
                method: "GET",
                path: `/contests/${encodeURIComponent(contestId)}/state`,
                endpoint: "contestState.get",
                dataSchema: contestStateSchema,
            });
        }
        catch (e) {
            if (e instanceof OpenMarketsError && e.status === 404) {
                return { data: null, rateLimit: this.http.lastRateLimit };
            }
            throw e;
        }
    }
    /**
     * Batch state lookup (max 200 ids). `data` is a map keyed by contest_id;
     * contests with no cached state are silently omitted (no per-id 404).
     */
    batch(contestIds) {
        return this.http.request({
            method: "POST",
            path: "/contest-state/batch",
            endpoint: "contestState.batch",
            body: { contest_ids: contestIds },
            dataSchema: contestStateBatchSchema,
        });
    }
}
//# sourceMappingURL=contest-state.js.map